import { bootstrapApplication } from "@angular/platform-browser";
import {
  provideZonelessChangeDetection,
  provideBrowserGlobalErrorListeners,
} from "@angular/core";
import { AppComponent } from "./app.component";
import { migrateVfToCastOffPro } from "./core/storage/migrate-vf-to-castoffpro";
import { provideCastOffProI18n } from "./core/i18n/i18n.providers";

// Migrate legacy `vf.*` storage keys to the new `castoffpro.*` namespace BEFORE
// Angular boots — services and simulation-core entry points read the new
// keys synchronously during construction, so the copy must complete first.
migrateVfToCastOffPro();

bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    ...provideCastOffProI18n(),
  ],
}).catch((err) => console.error(err));
